import PrintersStore from './Printers';
import PrinterEditorStore from './PrinterEditor';

const Printers = new PrintersStore();
const PrinterEditor = new PrinterEditorStore(Printers);

export default {
  Printers,
  PrinterEditor,
};